import React, {Fragment, useState} from 'react'
import {Link} from 'react-router-dom'
import invert from 'invert-color'
import {formatNumber, formatDate} from 'admin/lib/format'
import AlertIcon from '../shared/AlertIcon'

const GroupTag = ({text, colour, collapsing = true}) => {
  const [collapse, setCollapse] = useState(true)
  const style = {}
  if (colour) {
    style.backgroundColor = `#${colour}`
    style.color = invert(`#${colour}`, true)
  }

  return collapsing ? (
    <span
      className='tag is-small'
      style={{...style, position: 'relative'}}
      onMouseEnter={() => setCollapse(false)}
      onMouseLeave={() => setCollapse(true)}>
      {text.substr(0, 1)}
      <span
        className={collapse ? 'is-hidden' : 'tag is-small'}
        style={{...style, position: 'absolute', left: 0, top: 0, zIndex: 10}}>
        {text}
      </span>
    </span>
  ) : (
    <span className='tag is-small' style={style}>
      {text}
    </span>
  )
}

export default ({onClick, data, SelectAll, SelectOne, organisation}) => {
  return (
    <table className='table is-striped is-hoverable is-fullwidth is-linked'>
      <colgroup>
        <col span='1' style={{width: '2%'}} />
        <col span='1' style={{width: '20%'}} />
      </colgroup>
      <thead>
        <tr className='is-size-8'>
          <th>
            <SelectAll />
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th>Date created</th>
          <th>Last transaction date</th>
          <th>Balance</th>
        </tr>
      </thead>
      <tbody>
        {data.map((account, i) => {
          const absoluteBalance = formatNumber(Math.abs(account.balance))
          const handleRowClick = e => {
            do {
              if (e.target.tagName?.toLowerCase() == 'a' || e.target.type == 'checkbox') return
              e.target = e.target.parentNode
            } while (e.target)

            e.preventDefault()
            onClick(account.id)
          }
          return (
            <tr key={i} onClick={handleRowClick}>
              <td>
                <SelectOne identifier={account.id} />
              </td>
              <td className='has-text-weight-semibold'>
                <div className='columns is-mobile m-0 is-vcentered'>
                  <AlertIcon number={account.numOfAlerts} />
                  <div className='column'>
                    <span>{account.displayName}</span>
                    {account.displayName !== account.contactFullName ? <sub>{account.contactFullName}</sub> : null}
                    <sub>
                      {account.customerNumber ? <span># {account.customerNumber}</span> : null}
                      {organisation.smsEnabled && account.warnWhenOverdue ? (
                        <span className='icon ml-2'>
                          <i className='fa fa-sm fa-regular fa-bell' title='Sends SMS warnings when overdue'></i>
                        </span>
                      ) : null}
                      {organisation.featureFlags?.includes('running_balance_invoices') &&
                      account.useRunningBalanceInvoices ? (
                        <span className='icon ml-2'>
                          <i className='fa fa-sm fa-regular fa-file-lines' title='Uses running balance invoices'></i>
                        </span>
                      ) : null}
                    </sub>
                  </div>
                </div>
              </td>
              <td>
                <div className='tags m-0'>
                  {account.groups &&
                    account.groups.map((group, i) => (
                      <GroupTag
                        key={i}
                        text={group.name}
                        colour={group.colour}
                        collapsing={account.groups.length > 1}
                      />
                    ))}
                </div>
              </td>
              <td>
                <div className='buttons'>
                  {account.numOfActiveRepeatingInvoices > 0 ? (
                    <Link
                      to={`/orgs/${organisation.id}/repeating_invoices?q=${
                        account.customerNumber || account.displayName
                      }`}
                      className='button is-light is-small'>
                      <span className='icon is-small'>
                        <i className='fa fa-repeat'></i>
                      </span>
                      <span>{account.numOfActiveRepeatingInvoices}</span>
                    </Link>
                  ) : null}

                  {organisation.featureFlags?.includes('internet_services') &&
                  (account.numOfActiveServices > 0 || account.numOfInactiveServices > 0) ? (
                    <Link
                      to={`/orgs/${organisation.id}/services?q=${account.customerNumber || account.displayName}`}
                      className='button is-light is-small'>
                      {account.numOfActiveServices > 0 ? (
                        <Fragment>
                          <span className='icon is-small has-text-success'>
                            <i className='fa fa-ethernet'></i>
                          </span>
                          <span>{account.numOfActiveServices}</span>
                        </Fragment>
                      ) : null}
                      {account.numOfInactiveServices > 0 ? (
                        <Fragment>
                          {account.numOfActiveServices > 0 ? <span>&nbsp;</span> : null}
                          <span className='icon is-small has-text-danger'>
                            <i className='fa fa-ethernet'></i>
                          </span>
                          <span>{account.numOfInactiveServices}</span>
                        </Fragment>
                      ) : null}
                    </Link>
                  ) : null}
                </div>
              </td>
              <td>{formatDate(account.createdAt)}</td>
              <td>{account.lastTransactionDate}</td>
              <td>
                <span className={account.balance < 0 ? 'has-text-danger' : ''}>
                  {account.balance > 0 ? `(${absoluteBalance})` : absoluteBalance}
                </span>
                {account.overdueSince ? (
                  <sub className='has-text-danger'>
                    {-account.overdueAmount != account.balance
                      ? `${formatNumber(account.overdueAmount)} overdue`
                      : 'Overdue'}
                    {` since ${account.overdueSince}`}
                  </sub>
                ) : null}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
